import { useEffect, useState } from 'react';
import { api } from '../lib/api.ts';
interface Job { task: () => Promise<unknown>; resolve: (value: unknown) => void; reject: (error: unknown) => void; signal?: AbortSignal; abort: () => void }
let active = 0;
const waiting: Job[] = [];
function drain() {
  while (active < 2 && waiting.length) {
    const job = waiting.shift()!;
    job.signal?.removeEventListener('abort', job.abort);
    if (job.signal?.aborted) { job.reject(new DOMException('Aborted', 'AbortError')); continue; }
    active++;
    void Promise.resolve().then(() => { job.signal?.throwIfAborted(); return job.task(); })
      .then(job.resolve, job.reject).finally(() => { active--; drain(); });
  }
}
/** Bounded queue shared by imports/previews; cancelled waiters cannot strand free slots. */
export function iconTask<T>(task: () => Promise<T>, signal?: AbortSignal): Promise<T> {
  if (signal?.aborted) return Promise.reject(new DOMException('Aborted', 'AbortError'));
  if (waiting.length >= 16) return Promise.reject(new Error('Слишком много ожидающих картинок'));
  return new Promise<T>((resolve, reject) => {
    const job: Job = { task, resolve: (value) => resolve(value as T), reject, signal, abort: () => {
      const i = waiting.indexOf(job);
      if (i >= 0) { waiting.splice(i, 1); reject(new DOMException('Aborted', 'AbortError')); drain(); }
    } };
    waiting.push(job); signal?.addEventListener('abort', job.abort, { once: true }); drain();
  });
}
export function IconPreview({ url }: { url: string }) {
  const [src, setSrc] = useState('');
  useEffect(() => {
    const controller = new AbortController(); setSrc('');
    void iconTask(() => api<{ dataUrl: string }>('/icons/preview', { method: 'POST', body: { url }, signal: controller.signal }), controller.signal)
      .then((r) => { if (!controller.signal.aborted) setSrc(r.dataUrl); }).catch(() => {});
    return () => controller.abort();
  }, [url]);
  return src ? <img src={src} alt="" /> : <span aria-hidden>◌</span>;
}
